import React, { useState } from 'react';
import FormModalFormatter, { IFormModalFormatterProps } from './FormModalFormatter';
import getIn from '../../connectedForm/utils/getIn';

const LazySalesCreditForm = React.lazy(() => import('../../../views/salesLedger/salesCredit/SalesCreditForm'));

const SalesCreditFormModalFormatter = ({ value, dependentValues }: IFormModalFormatterProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const idValue = getIn(dependentValues.rowData, dependentValues.options?.entityId);

  return (
    <FormModalFormatter modalOpen={modalOpen} setModalOpen={setModalOpen} value={value}>
      <LazySalesCreditForm
        forceReadOnly={true}
        onClose={() => {
          setModalOpen(false);
        }}
        pageView={true}
        match={{ params: { id: idValue } }}
        overrideParams={{ id: idValue }}
      />
    </FormModalFormatter>
  );
};

export default SalesCreditFormModalFormatter;
